/* eslint-disable  */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
// import { useCallback } from "react";         Will be required later on
import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../utilities/axiosConfig';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { CLIENT_KEY, TWOFA_KEY } from '../config/keys';
import { jwtDecode } from 'jwt-decode';
import { SnackbarContext } from '../context/snackbarContext';
const useAuth = () => {
  const navigate = useNavigate();
  const params = useParams();
  const openSnackbar = useContext(SnackbarContext);

  const register = async (formValues) => {
    console.log('RegisterFormValues:', formValues);
    try {
      const response = await axios.post(
        '/user/signup',
        { ...formValues },
        { withCredentials: true, credentials: 'include' },
      );

      console.log('RESPONSE MESSAGE:', response.data.message);
      toast.success(`Registration successful! ${response.data.message}`, {
        autoClose: 7000,
        position: 'top-center',
      });
      navigate('/');
    } catch (error) {
      console.log('Error while signing up:', error);
      toast.error('Registration failed!', {
        autoClose: 2000,
        position: 'top-center',
      });
    }
  };

  const isFirstLogin = async (formValues) => {
    try {
      const response = await axios.post(
        '/user/is-first-time-login',
        { ...formValues },
        { withCredentials: true, credentials: 'include' },
      );
      if (response?.data) {
        // localStorage.setItem('email', response?.data?.email);
        localStorage.setItem('isFirstLogin', response?.data?.isFirstLogin);
        localStorage.setItem('isExistingUser', response?.data?.isExistingUser);
      }
      return response?.data;
    } catch (error) {
      console.log('Error while signing up:', error);
      toast.error('Registration failed!', {
        autoClose: 2000,
        position: 'top-center',
      });
      return null;
    }
  };

  const createPassword = async (formValues) => {
    try {
      const response = await axios.post(
        '/user/create-password',
        { ...formValues },
        { withCredentials: true, credentials: 'include' },
      );

      // console.log('RESPONSE MESSAGE:', response.data.message);
      // return response?.data;
      if (response?.data?.success) {
        const loginResponse = await login(formValues);
        if (loginResponse) {
          navigate('/homepage');
        }
      }
      return null;
    } catch (error) {
      console.log('Error while signing up:', error);
      toast.error('Registration failed!', {
        autoClose: 2000,
        position: 'top-center',
      });
      return null;
    }
  };

  const login = async (formValues) => {
    let response = null;
    try {
      response = await axios.post(
        '/user/login-web',
        { ...formValues },
        { withCredentials: true, credentials: 'include' },
      );

      if (response.data.key) {
        openSnackbar(response.data.message, 'success');
        return null;
      }
      console.log('LoginResponse:', response.data.success);
      if (response.data) {
        // navigate('/2fa');
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('name', response.data.first_name);
        return response;
        // navigate('/homepage');
      }
      return null;
    } catch (error) {
      console.log('Error while logging in:', error);
      openSnackbar(error?.response?.data?.message || 'Login Failed!', 'error');
      // toast.error('Login Failed!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
      return error?.response?.data;
    }
  };

  const forgotPassword = async (email) => {
    try {
      if (!email) {
        openSnackbar('Please enter email', 'error');
        return;
      }
      const response = await axios.post('/user/forgot-password', email, {
        withCredentials: true,
        credentials: 'include',
      });
      console.log('Response:', response);

      if (response.data.status) {
        openSnackbar(response.data.message, 'success');
        navigate('/email-sent');
      } else {
        openSnackbar('Please enter a registered email!', 'error');
      }
    } catch (error) {
      openSnackbar('Please enter a registered email!', 'error');
      // toast.error('Please enter a registered email!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
    }
  };

  const resetPassword = async (password) => {
    try {
      console.log('Password New:', password);
      const hashedPassword = CryptoJS.AES.encrypt(password?.hashedPassword, CLIENT_KEY).toString();
      console.log('HAshed password:', hashedPassword);
      const { isMobile } = password;
      const response = await axios.post(
        `/user/reset-password/${params.id}/${params.token}`,
        { hashedPassword, isMobile },
        { withCredentials: true, credentials: 'include' },
      );

      if (response.data.success) {
        openSnackbar(response.data.message, 'success');
        const loginResponse = await login({
          email: response?.data?.email,
          password: password?.hashedPassword,
        });
        if (loginResponse) {
          navigate('/homepage');
        }
        return response;
      }
      return null;
    } catch (error) {
      console.log('Password reset failed, please try again!', 'error');
      // toast.error('Password reset failed, please try again!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
      // navigate('/');
      return false;
    }
  };

  const updatePassword = async (passwordData) => {
    try {
      const { oldPassword, newPassword, emailId } = passwordData;
      // const hashedOldPassword = CryptoJS.AES.encrypt(oldPassword, CLIENT_KEY).toString();
      const hashedNewPassword = CryptoJS.AES.encrypt(newPassword, CLIENT_KEY).toString();

      const response = await axios.post(
        `/user/update-password`,
        { oldPassword, newPassword: hashedNewPassword, emailId },
        { withCredentials: true, credentials: 'include' },
      );

      if (response.data.success) {
        openSnackbar(response.data.message, 'success');
        return response;
      }
      return null;
    } catch (error) {
      console.log('Password update failed, please try again!', 'error');
      return false;
    }
  };

  const checkLinkExpiry = async (values) => {
    try {
      if (!values?.token || !values?.id) {
        openSnackbar('Invalid link', 'error');
        return;
      }
      const response = await axios.post('/user/check-link-expiry', values, {
        withCredentials: true,
        credentials: 'include',
      });

      if (response?.data?.success) {
        return response.data;
      } else {
        if (!response.data.linkExpired) {
          openSnackbar(response?.data?.message, 'error');
        } else {
          return response.data;
        }
      }
    } catch (error) {
      openSnackbar('Internal error', error);
      // toast.error('Please enter a registered email!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
    }
  };

  const twofavalidateotp = async (accesscode, data) => {
    const tempUser = Cookies.get('user');
    const decipheredUser = CryptoJS.AES.decrypt(tempUser, CLIENT_KEY);
    const user = decipheredUser.toString(CryptoJS.enc.Utf8);

    console.log('AccessCOde:', accesscode);
    console.log('Email:', user);

    // return { user, secret };

    try {
      const response = await axios.post(
        '/user/twofavalidateOtp',
        { accesscode, user, ...data },
        {
          withCredentials: true,
          credentials: 'include',
        },
      );
      if (response.data.isVerified) {
        localStorage.setItem('email', user);
        localStorage.setItem('name', response.data.userName);
        toast.success('Logged in successfully', {
          autoClose: 2000,
          position: 'top-center',
        });
        navigate('/homepage');
        // console.log("Hook Secret:", secret);
        // return { secret };
      }

      console.log('VALIDATE OTP RESPONSE:', response);
    } catch (error) {
      console.log('OTP verification failed:', error);
      Cookies.remove('token');
      Cookies.remove('user');
      Cookies.remove('temp_secret');
      navigate('/');
      toast.error('OTP Verification Failed! Please try again', {
        autoClose: 2000,
        position: 'top-center',
      });
    }
  };

  const logout = async () => {
    try {
      const response = await axios.post('/user/logout', {
        withCredentials: true,
        credentials: 'include',
      });

      if (Cookies.get('socialverified')) {
        window.open('http://localhost:9001/auth/logout', '_self');
      }
      if (response.data.success === true) {
        localStorage.removeItem('email');
        localStorage.removeItem('name');
        Cookies.remove('token');
        Cookies.remove('user');
        Cookies.remove('temp_secret');
        Cookies.remove('verified');
        localStorage.removeItem('selectedDrawerNavIndex');

        // openSnackbar('You have logged out!', 'success');
        navigate('/');
      }
    } catch (error) {
      console.log('Error while logging out:', error);
    }
  };
  /* eslint-disable */
  const addNewUser = async (formValues) => {
    try {
      const response = await axios.post(
        '/user/add-new-user',
        { ...formValues },
        { withCredentials: true, credentials: 'include' },
      );

      console.log('RESPONSE MESSAGE:', response.data.message);
      if (response.data.success) {
        // toast.success(`Registration successful! ${response.data.message}`, {
        //   autoClose: 7000,
        //   position: 'top-center',
        // });

        return response.data.success;
      }
    } catch (error) {
      console.log('Error while signing up:', error);
      // toast.error('Registration failed!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
    }
  };

  //edit user function
  const editUser = async (formValues) => {
    try {
      const response = await axios.post(
        '/user/edit-user',
        { ...formValues },
        { withCredentials: true, credentials: 'include' },
      );

      console.log('RESPONSE MESSAGE:', response.data.message);
      if (response.data.success) {
        // toast.success(`User edited successfully! ${response.data.message}`, {
        //   autoClose: 7000,
        //   position: 'top-center',
        // });

        return response;
      }
    } catch (error) {
      console.log('Error while editing user:', error);
      // toast.error('User edit failed!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
    }
  };

  const disableUser = async (userId) => {
    try {
      const response = await axios.post(
        '/user/disable-user-access',
        { userId },
        { withCredentials: true, credentials: 'include' },
      );

      console.log('RESPONSE MESSAGE:', response.data.message);
      if (response.data.success) {
        // toast.success(`User disabled successfully! ${response.data.message}`, {
        //   autoClose: 7000,
        //   position: 'top-center',
        // });

        return response.data.success;
      }
    } catch (error) {
      console.log('Error while disabling user:', error);
      // toast.error('User disable failed!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
    }
  };

  const restoreUser = async (userId) => {
    try {
      const response = await axios.post(
        '/user/restore-user-access',
        { userId },
        { withCredentials: true, credentials: 'include' },
      );

      console.log('RESPONSE MESSAGE:', response.data.message);
      if (response.data.success) {
        // toast.success(`${response.data.message}`, {
        //   autoClose: 7000,
        //   position: 'top-center',
        // });

        return response.data.success;
      }
    } catch (error) {
      console.log('Error while restoring user access:', error);
      // toast.error('User access restoration failed!', {
      //   autoClose: 2000,
      //   position: 'top-center',
      // });
    }
  };

  const fetchAccountSetupDetails = async (userId) => {
    try {
      const response = await axios.post(`/user/fetch-account-setup-details/${userId}`, {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('RESPONSE MESSAGE:', response.data.message);
      // if (response.data.success) {
      //   return response;
      // }
      return response;
    } catch (error) {
      console.log('Error while fetching user details:', error);
      if (error.response && error.response.data.message === 'Link expired') {
        // return the error response if the link is expired
        return error.response;
      } else if (error.response && error.response.data.message === 'Invalid link') {
        // return the error response if the link is expired
        return error.response;
      }
      return null;
    }
  };

  const setAccountSetupPassword = async (userId, password) => {
    try {
      const response = await axios.post(
        `/user/set-account-setup-password`,
        { userId, password },
        {
          withCredentials: true,
          credentials: 'include',
        },
      );

      console.log('RESPONSE MESSAGE:', response.data.message);
      if (response.data.success) {
        return response;
      }
    } catch (error) {
      console.log('Error while restoring user access:', error);
    }
  };

  const editLoggedInUserWithBase64Image = async (user) => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);

    const { user_uuid } = decoded;

    let userUpdateObj = {};

    userUpdateObj.user_uuid = user_uuid;

    if (user.first_name?.length != 0 && user.first_name != null) {
      userUpdateObj.first_name = user.first_name;
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      userUpdateObj.last_name = user.last_name;
    }
    if (user.phone != undefined && user.phone != null) {
      userUpdateObj.phone = user.phone;
    }
    if (user.email?.length != 0 && user.email != null) {
      userUpdateObj.email = user.email;
    }
    if (user.role_id || user.role_id == 0) {
      userUpdateObj.role_id = user.role_id;
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      userUpdateObj.imageFileData = user.imageFileData;
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      userUpdateObj.imageFileType = user.imageFileType;
    }

    // console.log("******** userUpdateObj = ", userUpdateObj)

    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/edit-user-with-base64-image', userUpdateObj);
        // console.log("******** response = ", response)
        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const editUUIDUserWithBase64Image = async (user) => {
    let userUpdateObj = {};

    userUpdateObj.user_uuid = user.user_uuid;

    if (user.first_name?.length != 0 && user.first_name != null) {
      userUpdateObj.first_name = user.first_name;
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      userUpdateObj.last_name = user.last_name;
    }
    if (user.phone != undefined && user.phone != null) {
      userUpdateObj.phone = user.phone;
    }
    if (user.email?.length != 0 && user.email != null) {
      userUpdateObj.email = user.email;
    }
    if (user.role_id || user.role_id == 0) {
      userUpdateObj.role_id = user.role_id;
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      userUpdateObj.imageFileData = user.imageFileData;
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      userUpdateObj.imageFileType = user.imageFileType;
    }
    if (user.is_active != undefined) {
      userUpdateObj.is_active = user.is_active;
    }
    if (user.sites && user.sites.length > 0) {
      userUpdateObj.sites = user.sites;
    }

    // console.log("******** userUpdateObj = ", userUpdateObj)

    if (userUpdateObj.user_uuid != null) {
      try {
        console.log(userUpdateObj, 4343);
        const response = await axios.post('/user/edit-user-with-base64-image', userUpdateObj);
        // console.log("******** response = ", response)
        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const editLoggedInUserWithImageBackendToAws = async (user) => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);
    const { user_uuid } = decoded;

    const formData = new FormData();
    formData.append('user_uuid', user_uuid);

    if (user.first_name?.length != 0 && user.first_name != null) {
      formData.append('first_name', user.first_name);
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      formData.append('last_name', user.last_name);
    }
    if (user.phone != undefined && user.phone != null) {
      formData.append('phone', user.phone);
    }
    if (user.email?.length != 0 && user.email != null) {
      formData.append('email', user.email);
    }
    if (user.role_id || user.role_id == 0) {
      formData.append('role_id', user.role_id);
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      formData.append('files', user.imageFileData);
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      formData.append('imageFileType', user.imageFileType);
    }

    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/edit-user-with-image-backend-to-aws', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        // console.log('******** response = ', response);
        if (response.data && response.data.success == true) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const editUUIDUserWithImageBackendToAws = async (user) => {
    const formData = new FormData();

    formData.append('user_uuid', user.user_uuid);

    if (user.first_name?.length != 0 && user.first_name != null) {
      formData.append('first_name', user.first_name);
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      formData.append('last_name', user.last_name);
    }
    if (user.phone != undefined && user.phone != null) {
      formData.append('phone', user.phone);
    }
    if (user.email?.length != 0 && user.email != null) {
      formData.append('email', user.email);
    }
    if (user.role_id || user.role_id == 0) {
      formData.append('role_id', user.role_id);
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      formData.append('files', user.imageFileData);
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      formData.append('imageFileType', user.imageFileType);
    }
    if (user.is_active != undefined) {
      formData.append('is_active', user.is_active);
    }
    if (user.sites && user.sites.length > 0) {
      formData.append('sites', JSON.stringify(user.sites));
    }
    if (user.clearProfilePic && user.clearProfilePic == true) {
      formData.append('clearProfilePic', user.clearProfilePic);
    }
    if (user.clearSiteAllocations && user.clearSiteAllocations == true) {
      formData.append('clearSiteAllocations', user.clearSiteAllocations);
    }

    if (user.user_uuid != null) {
      try {
        const response = await axios.post('/user/edit-user-with-image-backend-to-aws', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('******** response auth = ', response);
        if (response.data && response.data.success == true) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const createNewUserWithImageBackendToAws = async (user) => {
    const formData = new FormData();

    if (user.first_name?.length != 0 && user.first_name != null) {
      formData.append('first_name', user.first_name);
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      formData.append('last_name', user.last_name);
    }
    if (user.phone != undefined && user.phone != null) {
      formData.append('phone', user.phone);
    }
    if (user.email?.length != 0 && user.email != null) {
      formData.append('email', user.email);
    }
    if (user.role_id || user.role_id == 0) {
      formData.append('role_id', user.role_id);
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      formData.append('files', user.imageFileData);
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      formData.append('imageFileType', user.imageFileType);
    }
    if (user.is_active != undefined) {
      formData.append('is_active', user.is_active);
    }
    if (user.sites && user.sites.length > 0) {
      formData.append('sites', JSON.stringify(user.sites));
    }

    if (user != null) {
      try {
        const response = await axios.post('/user/create-user-with-image-backend-to-aws', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('******** response auth = ', response);
        if (response.data && response.data.success == true) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const getUserByUuidWithAwsImageUrl = async (user_uuid) => {
    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/get-user-by-uuid-with-aws-image-url', {
          user_uuid: user_uuid,
        });

        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const deleteUUIDUser = async (user) => {
    let userUpdateObj = {};
    // userUpdateObj.user_uuid = 'a451084f-43ed-4f57-a575-e4bca803e0e1' // for testing
    userUpdateObj.user_uuid = user.user_uuid;

    // console.log("userUpdateObj = ", userUpdateObj);
    if (userUpdateObj.user_uuid != null) {
      try {
        const response = await axios.post('/user/delete-uuid-user', userUpdateObj);
        // console.log("******** response.data = ", response.data)
        // {
        //   "success": true,
        //   "message": "User deleted"
        // }
        if (response.data?.message && response.data?.message == 'User deleted') {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    } else {
      return false;
    }
  };

  const unDeleteAndEditUUIDUserWithBase64Image = async (user) => {
    let userUpdateObj = {};

    userUpdateObj.user_uuid = user.user_uuid;

    if (user.first_name?.length != 0 && user.first_name != null) {
      userUpdateObj.first_name = user.first_name;
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      userUpdateObj.last_name = user.last_name;
    }
    if (user.phone != undefined && user.phone != null) {
      userUpdateObj.phone = user.phone;
    }
    if (user.email?.length != 0 && user.email != null) {
      userUpdateObj.email = user.email;
    }
    if (user.role_id || user.role_id == 0) {
      userUpdateObj.role_id = user.role_id;
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      userUpdateObj.imageFileData = user.imageFileData;
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      userUpdateObj.imageFileType = user.imageFileType;
    }
    if (user.is_active != undefined) {
      userUpdateObj.is_active = user.is_active;
    }

    // console.log("******** userUpdateObj = ", userUpdateObj)

    if (userUpdateObj.user_uuid != null) {
      try {
        const response = await axios.post(
          '/user/undelete-and-edit-uuid-user-with-base64-image',
          userUpdateObj,
        );
        // console.log("******** response = ", response)
        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const createNewUserWithBase64Image = async (user) => {
    let userUpdateObj = {};

    if (user.first_name?.length != 0 && user.first_name != null) {
      userUpdateObj.first_name = user.first_name;
    }
    if (user.last_name?.length != 0 && user.last_name != null) {
      userUpdateObj.last_name = user.last_name;
    }
    if (user.phone != undefined && user.phone != null) {
      userUpdateObj.phone = user.phone;
    }
    if (user.email?.length != 0 && user.email != null) {
      userUpdateObj.email = user.email;
    }
    if (user.role_id || user.role_id == 0) {
      userUpdateObj.role_id = user.role_id;
    }
    if (user.imageFileData?.length != 0 && user.imageFileData != null) {
      userUpdateObj.imageFileData = user.imageFileData;
    }
    if (user.imageFileType?.length != 0 && user.imageFileType != null) {
      userUpdateObj.imageFileType = user.imageFileType;
    }
    if (user.is_active != undefined) {
      userUpdateObj.is_active = user.is_active;
    }
    if (user.sites && user.sites.length > 0) {
      userUpdateObj.sites = user.sites;
    }

    console.log('******** userUpdateObj = ', userUpdateObj);

    if (userUpdateObj.email != null) {
      try {
        const response = await axios.post('/user/create-user-with-base64-image', userUpdateObj);
        console.log('******** response = ', response);
        if (response.data.user) {
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const deleteLoggedInUserDpImage = async () => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);

    const { user_uuid } = decoded;

    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/delete-user-dp-with-image-in-aws', {
          user_uuid: user_uuid,
        });

        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const deleteUUIDUserDpImage = async (user_uuid) => {
    console.log('user_uuid = ', user_uuid);

    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/delete-user-dp-with-image-in-aws', {
          user_uuid: user_uuid,
        });

        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const getUUIDUserDetails = async (user_uuid) => {
    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/get-user-by-user-uuid', {
          user_uuid: user_uuid,
        });

        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const getLoggedInUserDetails = async () => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);

    const { user_uuid } = decoded;

    if (user_uuid != null) {
      try {
        const response = await axios.post('/user/get-user-by-uuid-with-aws-image-url', {
          user_uuid: user_uuid,
        });

        if (response.data.user) {
          // const { first_name, last_name, profile_pic_url, email, phone } = response.data.user;
          return response.data.user;
        } else {
          console.log('Something went wrong while fetching user data');
        }
      } catch (error) {
        console.log('********* error:', error);
      }
    } else {
      console.log('Something went wrong while decoding token');
    }
  };

  const updateLoggedInUserPasswordWithOldPassword = async (passwordObj) => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);

    const { user_uuid } = decoded;

    let passwordUpdateObj = {};

    passwordUpdateObj.user_uuid = user_uuid;
    if (passwordObj.currentPassword?.length != 0 && passwordObj.currentPassword != null) {
      passwordUpdateObj.oldPassword = CryptoJS.AES.encrypt(
        passwordObj.currentPassword,
        CLIENT_KEY,
      ).toString();
    }
    if (passwordObj.newPassword?.length != 0 && passwordObj.newPassword != null) {
      passwordUpdateObj.newPassword = CryptoJS.AES.encrypt(
        passwordObj.newPassword,
        CLIENT_KEY,
      ).toString();
    }

    console.log('passwordUpdateObj = ', passwordUpdateObj);

    if (user_uuid != null) {
      try {
        const response = await axios.post(
          '/user/change-password-using-old-password-and-new-password',
          passwordUpdateObj,
        );
        if (response.data) {
          return response.data;
        } else {
          return 'failure';
        }
      } catch (error) {
        console.log('********* error:', error);
        return 'failure';
      }
    } else {
      return 'failure';
    }
  };

  const validateCurrentUserWithPassword = async (currentPassword) => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);

    const { user_uuid } = decoded;

    let currentUserObj = {};

    const hashedPassword = CryptoJS.AES.encrypt(currentPassword, CLIENT_KEY).toString();
    currentUserObj.user_uuid = user_uuid;
    currentUserObj.currentPassword = hashedPassword;

    if (user_uuid != null) {
      try {
        const response = await axios.post(
          '/user/validate-current-user-with-password',
          currentUserObj,
        );

        // console.log('*********** response.data useAuth= ', response.data)

        if (response.data) {
          return response.data;
        } else {
          return 'failure';
        }
      } catch (error) {
        return 'failure';
      }
    } else {
      return 'failure';
    }
  };

  const checkIfLoggedInUserEmailAddressIsUsedByAnotherUser = async (email) => {
    const tokenCookie = Cookies.get('token');
    const decoded = jwtDecode(tokenCookie);

    const { user_uuid } = decoded;

    let currentUserObj = {};

    currentUserObj.user_uuid = user_uuid;
    currentUserObj.email = email;

    if (user_uuid != null) {
      try {
        const response = await axios.post(
          '/user/check-if-email-address-is-used-by-another-user',
          currentUserObj,
        );

        // console.log('*********** response.data useAuth= ', response.data)

        if (response.data) {
          return response.data;
        } else {
          return 'failure';
        }
      } catch (error) {
        return 'failure';
      }
    } else {
      return 'failure';
    }
  };

  const checkIfUUIDUserEmailAddressIsUsedByAnotherUser = async (user_uuid, email) => {
    let currentUserObj = {};
    currentUserObj.user_uuid = user_uuid;
    currentUserObj.email = email;

    if (user_uuid != null) {
      try {
        const response = await axios.post(
          '/user/check-if-email-address-is-used-by-another-user',
          currentUserObj,
        );

        // console.log('*********** response.data useAuth= ', response.data)

        if (response.data) {
          return response.data;
        } else {
          return 'failure';
        }
      } catch (error) {
        return 'failure';
      }
    } else {
      return 'failure';
    }
  };

  const checkIfNewUserEmailAddressIsUsedByAnotherUser = async (email) => {
    let currentUserObj = {};
    currentUserObj.email = email;

    if (email && email != '') {
      try {
        const response = await axios.post(
          '/user/check-if-new-user-email-address-is-used-by-another-user',
          currentUserObj,
        );

        // console.log('*********** response.data useAuth= ', response.data)

        if (response.data) {
          return response.data;
        } else {
          return 'failure';
        }
      } catch (error) {
        return 'failure';
      }
    } else {
      return 'failure';
    }
  };

  return {
    register,
    isFirstLogin,
    createPassword,
    login,
    logout,
    twofavalidateotp,
    forgotPassword,
    resetPassword,
    addNewUser,
    editUser,
    disableUser,
    restoreUser,
    fetchAccountSetupDetails,
    setAccountSetupPassword,
    editLoggedInUserWithBase64Image,
    editUUIDUserWithBase64Image,

    editLoggedInUserWithImageBackendToAws,
    editUUIDUserWithImageBackendToAws,
    createNewUserWithImageBackendToAws,
    getUserByUuidWithAwsImageUrl,

    unDeleteAndEditUUIDUserWithBase64Image,
    deleteUUIDUser,
    createNewUserWithBase64Image,
    deleteLoggedInUserDpImage,
    deleteUUIDUserDpImage,
    getLoggedInUserDetails,
    getUUIDUserDetails,
    updateLoggedInUserPasswordWithOldPassword,
    validateCurrentUserWithPassword,
    checkIfLoggedInUserEmailAddressIsUsedByAnotherUser,
    checkIfUUIDUserEmailAddressIsUsedByAnotherUser,
    checkIfNewUserEmailAddressIsUsedByAnotherUser,
    updatePassword,
    checkLinkExpiry,
  };
};

export default useAuth;
